export default "__VITE_ASSET__C1mPnpa5__"